import { randomIntFromInterval } from "../Utiltiy/SortingVisualizer";

function swap(arr:any[], i:number, j:number) {
  let temp = arr[i];
  arr[i] = arr[j];
  arr[j] = temp;
}
export function getMergeSortAnimations(array:number[]) {
  const animations: any[] = [];
  if (array.length <= 1) return array;
  const auxiliaryArray = array.slice();
  mergeSortHelper(array, 0, array.length - 1, auxiliaryArray, animations);
  return animations;
}

function mergeSortHelper(
  mainArray: number[],
  startIdx: number,
  endIdx: number,
  auxiliaryArray: number[],
  animations: any[],
) {
  if (startIdx === endIdx) return;
  const middleIdx = Math.floor((startIdx + endIdx) / 2);
  mergeSortHelper(auxiliaryArray, startIdx, middleIdx, mainArray, animations);
  mergeSortHelper(auxiliaryArray, middleIdx + 1, endIdx, mainArray, animations);
  doMerge(mainArray, startIdx, middleIdx, endIdx, auxiliaryArray, animations);
}

function doMerge(
  mainArray: any[],
  startIdx: any,
  middleIdx: number,
  endIdx: number,
  auxiliaryArray: any[],
  animations: any[],
) {
  let k = startIdx;
  let i = startIdx;
  let j = middleIdx + 1;
  while (i <= middleIdx && j <= endIdx) {
    // These are the values that we're comparing; we push them once
    // to change their color.
    animations.push([i, j, false, true]);
    // These are the values that we're comparing; we push them a second
    // time to revert their color.
    animations.push([i, j, false, false]);
    if (auxiliaryArray[i] <= auxiliaryArray[j]) {
      // We overwrite the value at index k in the original array with the
      // value at index i in the auxiliary array.
      animations.push([k, auxiliaryArray[i], true, true]);
      mainArray[k++] = auxiliaryArray[i++];
    } else {
      // We overwrite the value at index k in the original array with the
      // value at index j in the auxiliary array.
      animations.push([k, auxiliaryArray[j], true, true]);
      mainArray[k++] = auxiliaryArray[j++];
    }
  }
  while (i <= middleIdx) {
    // These are the values that we're comparing; we push them once
    // to change their color.
    animations.push([i, i, false, true]);
    // These are the values that we're comparing; we push them a second
    // time to revert their color.
    animations.push([i, i, false, false]);
    // We overwrite the value at index k in the original array with the
    // value at index i in the auxiliary array.
    animations.push([k, auxiliaryArray[i], true, true]);
    mainArray[k++] = auxiliaryArray[i++];
  }
  while (j <= endIdx) {
    // These are the values that we're comparing; we push them once
    // to change their color.
    animations.push([j, j, false, true]);
    // These are the values that we're comparing; we push them a second
    // time to revert their color.
    animations.push([j, j, false, false]);
    // We overwrite the value at index k in the original array with the
    // value at index j in the auxiliary array.
    animations.push([k, auxiliaryArray[j], true, true]);
    mainArray[k++] = auxiliaryArray[j++];
  }
}

export function getQuickSortAnimations(array:number[],isRandomPivot: boolean) {
  const animations: any[] = [];
  if (array.length <= 1) return array;
  quickSortHelper(array, 0, array.length - 1, animations, isRandomPivot);
  return animations;
}


function quickSort(  
  array: any[],
  low: any,
  high: number,
  animations: any[],
  isRandomPivot = false,
  ) {
    if(isRandomPivot) {
      const randomIndex = randomIntFromInterval(low, high);
      animations.push([randomIndex, high, false, true]);
      animations.push([randomIndex, array[high], true, true]);
      animations.push([high, array[randomIndex], true, true]);
      animations.push([randomIndex, high, false, false]);
      swap(array, randomIndex, high);
    } 
    let pivot = array[high];
    animations.push([high, high, false, true]);
    let i = (low - 1);
    for (let j = low; j <= high - 1; j++) {
        animations.push([j, high, false, true]);
        animations.push([j, high, false, false]);
        if (array[j] < pivot) {
            i++;
            animations.push([i, array[j], true, true]);
            animations.push([j, array[i], true, true]);
            swap(array, i, j);
        }
    }
    animations.push([high, high, false, false]);
    animations.push([i + 1, high, false, true]);
    animations.push([i + 1, high, false, false]);
    animations.push([i+1, array[high], true, true]);
    animations.push([high, array[i+1], true, true]);
    swap(array, i + 1, high);
    return (i + 1);
}
function quickSortHelper(  
  array: any[],
  low: any,
  high: number,
  animations: any[],
  isRandomPivot = false,
  ) {
    if (low < high) {
        let pi = quickSort(array, low, high, animations, isRandomPivot);
        quickSortHelper(array, low, pi - 1, animations, isRandomPivot);
        quickSortHelper(array, pi + 1, high, animations, isRandomPivot);
    }
}

export function getHeapSortAnimations(array:number[]) {
  const animations: any[] = [];
  if (array.length <= 1) return array;
  heapSortHelper(array, animations);
  return animations;
}

function heapSortHelper(array: any[], animations: any[]) {
  var n = array.length;
  for (let i = Math.floor(n / 2) - 1; i >= 0; i--) heapify(array, n, i, animations);
  for (let i = n - 1; i > 0; i--) {
    animations.push([i, 0, false, true]);
    animations.push([i, 0, false, false]);
    animations.push([i, array[0], true, true]);
    animations.push([0, array[i], true, true]);
    swap(array,0,i);
    heapify(array, i, 0, animations);
  }
}
function heapify(array: any[], n: number, i: number, animations: any[]) {
  var largest = i; 
  var l = 2 * i + 1; 
  var r = 2 * i + 2; 
  if (l < n && array[l] > array[largest]) largest = l;
  if (r < n && array[r] > array[largest]) largest = r;
  animations.push([i, largest, false, true]);
  animations.push([i, largest, false, false]);
  if (largest !== i) {
    animations.push([i, array[largest], true, true]);
    animations.push([largest, array[i], true, true]);
    swap(array,i,largest);
    heapify(array, n, largest, animations);
  }
}
export function getBubbleSortAnimations(array: any[]){
  const animations: any[] = [];
  if (array.length <= 1) return array;
  bubblesortHelper(array, animations);
  return animations;
}
function bubblesortHelper(array: any[], animations: any[]) {
		var swapped=true; 
		var i=0;
    var size = array.length;
		while(swapped)
		{
			swapped=false;
			i=1;
			while( i < size)
			{
        animations.push([i, i-1, false, true]);
        animations.push([i, i-1, false, false]);
				if(array[i-1] > array[i])
				{
          animations.push([i, array[i-1], true, true]);
          animations.push([i-1, array[i], true, true]);
          swap(array, i, i-1);
					swapped=true;
				}
				i=i+1;
			}
		}
	}